// extracted by mini-css-extract-plugin
export var clients = "clients-module--clients--maoMc";
export var clients__desc = "clients-module--clients__desc--2x6H3";
export var clients__logoWrapper = "clients-module--clients__logo-wrapper--2upiI";
export var clients__logo = "clients-module--clients__logo--6fAaP";
export var clients__logoList = "clients-module--clients__logo-list--o5fBs";